import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../ReducerRegister";
import EditService from "../../../../services/screens/admin/contact/EditService";
import { ActionTypes } from "../../../actionTypes/screens/admin/contact/EditActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";

import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.contact.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: id => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, id });

            EditService.loadScreenView(
                id,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveContactAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_CONTACT_ASYNC, vo });

            EditService.saveContact(
                vo,
                response => {
                    dispatch(Actions.saveContactSuccess(response));
                },
                error => {
                    dispatch(Actions.saveContactFailure(error));
                }
            );
        };
    },

    saveContactSuccess: data => ({
        type: ActionTypes.SAVE_CONTACT_SUCCESS,
        parentType: ActionTypes.SAVE_CONTACT_ASYNC,
        data
    }),

    saveContactFailure: error => ({
        type: ActionTypes.SAVE_CONTACT_FAILURE,
        parentType: ActionTypes.SAVE_CONTACT_ASYNC,
        error
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    contact: null
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, contact: data.contact };
};

// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_CONTACT_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_CONTACT_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_CONTACT_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
